import React from "react";
import { useWebData } from "../../Context/webDataContext";
import { Link } from "react-router-dom";

function OurBlogsDynamic() {
  const { getBlogData } = useWebData();
  const blogs = getBlogData();
  const latestBlogs = blogs.slice(0, 3);

  return (
    <section className="py-6" id="blogs">
      <h2 className="text-2xl md:text-4xl font-bold primary-text lato md:mb-8 mb-2 md:text-left text-center">
        Our Blogs
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        {latestBlogs.map((blog) => (
          <div
            key={blog.id}
            className="bg-[#F1F1F1] shadow-lg rounded-xl p-6 flex flex-col justify-between transition-transform duration-300 hover:scale-105"
          >
            {/* Blog Type and Time */}
            <div className="flex items-center text-sm text-gray-600 mb-3">
              <span
                className={`inline-block w-3 h-3 rounded-full mr-2 primary-bg`}
              ></span>
              <span>{blog.readingTime || "5 min"}</span>
            </div>

            {/* Blog Image */}
            <div className="w-full h-44 lg:h-60 rounded-md overflow-hidden mb-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-5">
              {blog.blogHeader}
            </h3>
              <img
                src={blog.blogImage || "https://via.placeholder.com/600x400"}
                alt={blog.blogHeader}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
              />
            </div>

            {/* Blog Content */}
        
            <p className="text-sm text-gray-600 mb-4">
              {blog.paragraph.slice(0, 60)}...
            </p>

            {/* Read More Button Inside the Box (Right-Aligned) */}
            <div className="flex justify-end">
              <Link
                to={`/blog/${blog.id}`}
                className="w-10 h-10 rounded-full border border-[#08875D] flex items-center justify-center transition-all hover:bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)]  hover:text-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="w-5 h-5 text-green-700 hover:text-white transition-all"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                  />
                </svg>
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* View More Button (Centered) */}
      <div className="mt-10 flex justify-center">
        <Link
          to="/blog"
          className=" bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)] text-white text-xl font-semibold py-3 px-8 rounded-md shadow-md transition-all"
        >
          View More
        </Link>
      </div>
    </section>
  );
}

export default OurBlogsDynamic;
